/**
 * A Firebase ID token for a request that comes after a long upload.
 *
 * ID tokens last one hour. Uploads capture a token before the PUT, and a large
 * file (up to 25 GB) on an ordinary connection can take longer than that, so the
 * "complete" call after the PUT would be refused as signed out. getIdToken(false)
 * returns the cached token, or a refreshed one if it has expired.
 *
 * Falls back to the token the caller already had (e2e auth bypass, tests, or
 * no signed-in Firebase user).
 */
export async function currentIdToken(fallback: string): Promise<string> {
  try {
    const { auth } = await import('../firebaseConfig');
    const fresh = await auth?.currentUser?.getIdToken(false);
    return fresh || fallback;
  } catch {
    return fallback;
  }
}
